export * from "./auth.guard";
export * from "./role.guard";
export * from "./confirm.guard";


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/guards/index.ts